<script lang="ts" setup>
import { useVModel } from '@vueuse/core'

const props = defineProps<{
  modelValue?: string
  error?: string
  label: string
  type?: 'text' | 'email' | 'password' | 'tel'
  name: string
  id: string
}>()

const model = useVModel(props, 'modelValue')
</script>

<template>
  <input
    :id="props.id"
    :value="model"
    :aria-invalid="!!error"
    :aria-describedby="error ? 'subscribe-email-error' : undefined"
    :type="props.type"
    :name="name"
    :placeholder="label"
    class="card h-[40px] w-full pl-[56px] pr-[16px] text-gray-700"
    @input="
      (e: any) => {
        model = e.target.value
      }
    "
  />
</template>
